export * from './DocumentParts';